import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { RegisterInvoiceService } from '../../service/invoice/RegisterInvoiceService';
import { TokenService } from '../he-thong/chung-thu-so/TokenService';
import { ReportService } from '../bao-cao/ReportService';
import { TenantCompanyService } from '../he-thong/doanh-nghiep/thong-tin-doanh-nghiep/TenantCompanyService';
import { AppStorage } from '../../service/UserStorage';

import { FormatDisplay } from '../../shared/format';
import { ROLE } from '../../Constant';
import EventEmitter from '../../utils/EventEmitter';
import { useDialogRegisterInvoice } from './item/DialogRegisterInvoice';
import { InfoDialogService } from '../../AppInfoDialog';
import { Chart } from 'primereact/chart';
import { Dropdown } from 'primereact/dropdown';
import { DashboardService } from './DashboradService';
import { AmountToWord } from '../../service/AmountToWord';
import moment from 'moment';

const options = [
  { label: "Tuần này", value: "timeline=this-week" },
  { label: "Tháng này", value: "timeline=this-month" },
  { label: "Quý này", value: "timeline=this-quarter" },
  { label: "Năm nay", value: "timeline=this-year" },
  { label: "6 tháng đầu năm", value: "timeline=first-6-month" },
  { label: "6 tháng cuối năm", value: "timeline=last-6-month" },
  { label: "Tháng 1", value: "timeline=by-month&month=1" },
  { label: "Tháng 2", value: "timeline=by-month&month=2" },
  { label: "Tháng 3", value: "timeline=by-month&month=3" },
  { label: "Tháng 4", value: "timeline=by-month&month=4" },
  { label: "Tháng 5", value: "timeline=by-month&month=5" },
  { label: "Tháng 6", value: "timeline=by-month&month=6" },
  { label: "Tháng 7", value: "timeline=by-month&month=7" },
  { label: "Tháng 8", value: "timeline=by-month&month=8" },
  { label: "Tháng 9", value: "timeline=by-month&month=9" },
  { label: "Tháng 10", value: "timeline=by-month&month=10" },
  { label: "Tháng 11", value: "timeline=by-month&month=11" },
  { label: "Tháng 12", value: "timeline=by-month&month=12" },
  { label: "Quý I", value: "timeline=by-quarter&quarter=1" },
  { label: "Quý II", value: "timeline=by-quarter&quarter=2" },
  { label: "Quý III", value: "timeline=by-quarter&quarter=3" },
  { label: "Quý IV", value: "timeline=by-quarter&quarter=4" },
  { label: "Tuần trước", value: "timeline=last-week" },
  { label: "Tháng trước", value: "timeline=last-month" },
  { label: "Quý trước", value: "timeline=last-quarter" },
  { label: "Năm trước", value: "timeline=last-year" },
]

const colors = [
  "#ff2531",
  "#ff7c00",
  "#fea200",
  "#fff301",
  "#56c222",
  "#00a856",
  "#02afae",
  "#0165b9",
  "#1b3d9f",
  "#612697"
];

export default function Dashboard() {
  const [summaryReport, setSummaryReport] = useState(null);
  const [licence, setLicence] = useState(null);
  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [displaySelectInvoice, setDisplaySelectInvoice] = useState(false);
  const [tokens, setTokens] = useState([]);
  // const [tenantData, setTenantData] = useState(null);
  const [chartData, setChartData] = useState(null)
  const [chartOptions, setChartOptions] = useState({
    scales: {
      y: {
        beginAtZero: true
      }
    },
    plugins: {
      legend: {
        display: false
      }
    }
  })
  const [orderInfo, setOrderInfo] = useState(null)
  const [saleInfo, setSaleInfo] = useState(null)
  const [licenseInfo, setLicenseInfo] = useState(null)
  const [dashboardFilterValue, setDashboardFilterValue] = useState("timeline=this-year")
  const [orderInfoFilterValue, setOrderInfoFilterValue] = useState("timeline=this-year")
  const [saleInfoFilterValue, setSaleInfoFilterValue] = useState("timeline=this-year")
  const navigate = useNavigate();

  useEffect(() => {
    setDisplaySelectInvoice(true);
    // TenantCompanyService.get(AppStorage.get('__tenant')).then(data => {
    //   console.log(data)
    //   document.title = data.name + '-' + data.taxCode;
    //   AppStorage.set('tenantInfo', JSON.stringify(data));
    //   setTenantData(data);
    //   EventEmitter.emit("changeTenantInfo", data);
    // });
    DashboardService.getOrderInfo("timeline=this-year").then(res => setOrderInfo(res))
    DashboardService.getSaleInfo("timeline=this-year").then(res => setSaleInfo(res))
    DashboardService.getLicenseInfo().then(res => setLicenseInfo(res))
    DashboardService.getDashboard("timeline=this-year").then(res => {
      const result = res.reduce((acc, item) => {
        acc.labels.push(item.label);
        acc.data.push(item.orders);
        return acc;
      }, { labels: [], data: [] });
      setChartData({
        labels: result.labels,
        datasets: [{
          data: result.data,
          backgroundColor: [
            '#1878F3'
          ],
          borderRadius: 8,
        }]
      })
    })
  }, []);

  const handleChangeOptions = (type, value) => {
    switch (type) {
      case "dashboard":
        setDashboardFilterValue(value)
        DashboardService.getDashboard(value).then(res => {
          const result = res.reduce((acc, item) => {
            acc.labels.push(item.label);
            acc.data.push(item.orders);
            return acc;
          }, { labels: [], data: [] });
          setChartData({
            labels: result.labels,
            datasets: [{
              data: result.data,
              backgroundColor: [
                '#1878F3'
              ],
              borderRadius: 8,
            }]
          })
        })
        break;
      case "orderInfo":
        setOrderInfoFilterValue(value)
        DashboardService.getOrderInfo(value).then(res => setOrderInfo(res))
        break;
      case "saleInfo":
        setSaleInfoFilterValue(value)
        DashboardService.getSaleInfo(value).then(res => setSaleInfo(res))
        break;
      default:
        break;
    }
  }

  return (
    <div className="grid pt-3">
      <div className='col-6'>
        <div className='grid'>
          <div className='col-4'>
            <div className='p-3 card flex gap-3 flex-column h-full'>
              <div className='flex align-items-center gap-3'>
                <div style={{ width: 48, height: 48 }}>
                  <img src="/images/sales-order.png" alt="" style={{ width: '100%' }} />
                </div>
                <p className='text-xl font-bold'>Đơn hàng</p>
              </div>
              <div>
                <Dropdown options={options} defaultValue="this-year" value={orderInfoFilterValue} onChange={(e) => handleChangeOptions("orderInfo", e.value)} />
              </div>
              <div className='flex justify-content-between'>
                <div>
                  <p>Tổng số đơn hàng</p>
                  <p className='text-3xl font-bold'>{orderInfo?.totalOrder}</p>
                </div>
                <div>
                  <p>Đã xuất hóa đơn</p>
                  <p className='text-3xl font-bold'>{orderInfo?.totalOrderInvoice}</p>
                </div>
              </div>
            </div>
          </div>

          <div className='col-4'>
            <div className='p-3 card flex gap-3 flex-column h-full'>
              <div className='flex align-items-center gap-3'>
                <div style={{ width: 48, height: 48 }}>
                  <img src="/images/profit.png" alt="" style={{ width: '100%' }} />
                </div>
                <p className='text-xl font-bold'>Doanh số</p>
              </div>
              <div>
                <Dropdown options={options} defaultValue="this-year" value={saleInfoFilterValue} onChange={(e) => handleChangeOptions("saleInfo", e.value)} />

              </div>
              <div className='flex justify-content-between'>
                <div>
                  <p>Theo đơn hàng</p>
                  <p className='text-3xl font-bold'>{AmountToWord.docSoLamTron(saleInfo?.totalOrderAmount)}</p>
                </div>
                <div>
                  <p>Theo hóa đơn</p>
                  <p className='text-3xl font-bold'>{AmountToWord.docSoLamTron(saleInfo?.totalOrderInvoiceAmount)}</p>
                </div>
              </div>
            </div>
          </div>

          <div className='col-4 '>
            <div className='p-3 card flex justify-content-between flex-column h-full'>
              <div className='flex align-items-center gap-3'>
                <div style={{ width: 48, height: 48 }}>
                  <img src="/images/license2.png" alt="" style={{ width: '100%' }} />
                </div>
                <p className='text-xl font-bold'>Bản quyền</p>
              </div>
              <div className='flex align-items-center gap-3'>
                <p className='mb-0'>Thời hạn bản quyền</p>
                <p className='text-xl font-bold'>{moment(licenseInfo?.copyrightTerm).format("DD/MM/YYYY")}</p>
              </div>
              <div className='flex align-items-center gap-3'>
                <p className='mb-0'>Còn lại</p>
                <p className='text-xl font-bold'>{licenseInfo?.remaining}</p>
              </div>

              {/* <div className='flex justify-content-between'>
                <div>
                  <p className='text-lg font-bold'>Theo đơn hàng</p>
                  <p className='text-3xl font-bold'>248</p>
                </div>
                <div>
                  <p className='text-lg font-bold'>Theo hóa đơn</p>
                  <p className='text-3xl font-bold'>248</p>
                </div>
              </div> */}
            </div>
          </div>

          <div className='col-12'>
            <div className='p-3 card'>
              <div className='flex justify-content-between align-items-center'>
                <p className='text-xl mb-0'>THỐNG KÊ ĐƠN HÀNG THEO THỜI GIAN</p>
                <Dropdown options={options} defaultValue="this-year" value={dashboardFilterValue} onChange={(e) => handleChangeOptions("dashboard", e.value)} />
              </div>
              <Chart type="bar" data={chartData} options={chartOptions} />
            </div>
          </div>
        </div>
      </div>
      <div className='col-6'>
        <div className='grid'>
          <div className='col-12'>
            <div className='p-3 card'>
              <p className='text-xl'>DANH SÁCH ĐƠN HÀNG CHƯA XUẤT HÓA ĐƠN ({orderInfo?.totalOrderNotExported})</p>
              <DataTable value={orderInfo?.dashboardOrders}>
                <Column align='center' body={(data, options) => <div style={{ width: 16, height: 16, background: colors[options.rowIndex] }}></div>} bodyStyle={{ width: 20 }}></Column>
                <Column field='orderDate' header='NGÀY ĐƠN HÀNG' align='center' body={(data) => moment(data.orderDate).format("DD/MM/YYYY HH:mm")}></Column>
                <Column field='orderNumber' header='SỐ ĐƠN HÀNG' align='center'></Column>
                <Column field='buyerDisplayName' header='KHÁCH HÀNG'></Column>
                <Column field='totalAmount' header='TỔNG TIỀN' align='right' body={(data) => FormatDisplay.number(data.totalAmount)}></Column>
              </DataTable>
              <div className='mt-3 flex justify-content-end align-content-center'>
                <Button className='p-button-text' label="Xem thêm >" onClick={() => navigate("/ban-hang/don-hang", { state: { orderStatus: "2" } })} />
              </div>
            </div>
          </div>
          <div className='col-12'>
            <img src="/images/Banner.jpeg" alt="" style={{ width: '100%' }} />
          </div>
        </div>

      </div>
    </div>
  );
}
